import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login") && !url.includes("/public/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function openPdf(url) {
  const w = window.open("", "_blank");
  const r = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(r.data);
  if (w) w.location.href = blobUrl;
  else window.location.href = blobUrl;
}

let templatePromise = null;
export function loadTemplate() {
  templatePromise = templatePromise || api.get("/template").then((r) => r.data).catch((e) => { templatePromise = null; throw e; });
  return templatePromise;
}

export function fmtValue(f, v) {
  if (v === null || v === undefined || v === "") return "";
  if (f.type === "guarantor") return [v.chi, v.note].filter(Boolean).join(" • ");
  if (f.type === "date") {
    const [y, m, d] = String(v).split("-");
    return d ? `${d}/${m}/${y}` : v;
  }
  if (f.type === "datetime") {
    const [date, time] = String(v).split("T");
    return `${fmtValue({ type: "date" }, date)}${time ? " ore " + time.slice(0, 5) : ""}`;
  }
  if (f.type === "money") return fmtMoney(v);
  return String(v);
}

export function fmtMoney(v) {
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return "€ " + n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
